import { render, staticRenderFns } from "./UMESRFindings.vue?vue&type=template&id=47e60673&"
import script from "./UMESRFindings.vue?vue&type=script&lang=js&"
export * from "./UMESRFindings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports